import React, { useState } from 'react';
import cx from 'classnames';
import { createPortal } from 'react-dom';

import Card from '@marketing/components/card';
import { QuoteCard } from '@marketing/components/testimonial_card';
import HighlightedText from '@marketing/components/highlighted_text';
import SectionHeader from '@marketing/components/section_header';
import UnderlinedText from '@marketing/components/underlined_text';

import HeartIcon from './assets/heart_icon.svg';
import StudentHeadshot from './assets/student_headshot.png';
import colors from '@magoosh/lib/styles/colors.module.scss';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

const WallOfLove: React.FC<{}> = (props) => {
  const [displayVideoPlayer, setDisplayVideoPlayer] = useState<boolean>(false);

  return (
    <div className="d-flex flex-column gap-l" style={{ position: 'relative' }}>
      <div
        className={cx(marketingStyles.fullPageWidthContainerBreakout, marketingStyles.purpleGradientBg)}
        style={{ position: 'absolute', height: 900, top: -50, zIndex: -1 }}
      />

      <SectionHeader
        subtitle="Check out what others say about us."
        supertitle="Wall of love"
        supertitleIcon={HeartIcon}
        title={<>More students choose <UnderlinedText color={colors.brandSecondary}>Magoosh</UnderlinedText> than anyone else.</>}
      />

      <div className={cx(styles.wallOfLoveContainer, 'd-flex flex-column gap-m')}>
        <QuoteCard
          image={{
            alt: "Image of the student's face",
            height: '329px',
            onClick: () => setDisplayVideoPlayer(true),
            src: StudentHeadshot,
            width: '409px'
          }}
          studentAffiliation="Magoosh Student - 2021"
          studentName="Eleanore P."
        >
          "The best thing for me about Magoosh was <HighlightedText color="#FCF0BF">the flexibility</HighlightedText> because I don't have a lot of free time.  I could come home in the evenings, do video lessons, and that made all the difference. Magoosh being within my price range was the difference between me potentially getting into grad school and not getting in anywhere."
        </QuoteCard>

        <div className={cx(styles.quoteCardsContainer, 'd-flex flex-row flex-wrap gap-m')}>
          <QuoteCard
            className={styles.quoteCard}
            studentAffiliation="Magoosh Student - 2025"
            studentName="Atharv V."
          >
            "Vast question bank provided for various levels of questions with helpful explanations. Also, <HighlightedText color="#FCF0BF">the AI tutor</HighlightedText> helped clear any further doubts."
          </QuoteCard>


          <QuoteCard
            className={styles.quoteCard}
            studentAffiliation="Magoosh Student - 2023"
            studentName="Emily Z."
          >
            "There were plenty of practice questions and tests available, and everything was super easy to use! A bonus is that Magoosh has <HighlightedText color="#FCF0BF">official ETS practice sections</HighlightedText>, which is super helpful."
          </QuoteCard>

          <QuoteCard
            className={styles.quoteCard}
            studentAffiliation="Magoosh Student - 2023"
            studentName="Alexander W."
          >
            "<HighlightedText color="#FCF0BF">The vocab app</HighlightedText> was exceedingly helpful. That alone got me a bunch of questions on the Verbal Reasoning section of the actual exam."
          </QuoteCard>

          <QuoteCard
            className={styles.quoteCard}
            studentAffiliation="Magoosh Student - 2022"
            studentName="Sanjana D."
          >
            "The practice questions and practice tests were extremely useful. <HighlightedText color="#FCF0BF">The score predictor</HighlightedText> was on point and I ended up scoring the same as my last Magoosh practice test."
          </QuoteCard>
        </div>
      </div>

      {
        displayVideoPlayer && (
          createPortal(
            <>
              <div
                className={styles.pageOverlay}
                onClick={() => setDisplayVideoPlayer(false)}
              />

              <div className={cx(marketingStyles.purpleNoiseBg, styles.videoPlayerContainer)}>
                <div className={cx(styles.videoPlayerWrapper, 'd-flex flex-column')}>
                  <div
                    className="align-items-center bg-white d-flex gap-s"
                    style={{ borderRadius: '12px 12px 0 0', padding: 10 }}
                  >
                    <div className="flex-1 small"><strong>Eleanore P.</strong> - Magoosh Student - 2021</div>

                    <div>
                      <a className="small text-body" onClick={() => setDisplayVideoPlayer(false)}>
                        close video
                      </a>
                    </div>
                  </div>

                  <video autoPlay className={styles.videoPlayer} controls style={{ borderRadius: '0 0 12px 12px' }}>
                    <source src="https://d296n67kxwq0ge.cloudfront.net/audio_video/a8088d957a694715f2bf06bba05aba781afdb197-video-23093/web.mp4" type="video/mp4" />
                    <source src="https://d296n67kxwq0ge.cloudfront.net/audio_video/a8088d957a694715f2bf06bba05aba781afdb197-video-23093/web_webm.webm" type="video/webm" />
                  </video>
                </div>
              </div>
            </>,
            document.body
          )
        )
      }
    </div>
  );
};

export default WallOfLove;
